import { defineStore } from 'pinia';
import { LOCALE, LOCALE_LIST, type LocaleType } from '@mts-fe/utils';
import { LOCALE_KEY } from '@mts/enums/cacheEnum';
import { createLocalStorage } from '@mts/utils/cache';

const ls = createLocalStorage();

const localeSetting = {
  showPicker: true,
  // Locale
  locale: LOCALE.zh_CN,
  // Default locale
  fallback: LOCALE.zh_CN,
  // available Locales
  availableLocales: [LOCALE.zh_CN, LOCALE.zh_HK, LOCALE.en_US],
};

export const useLocaleStore = defineStore('app-locale', {
  state: () => ({
    localInfo: ls.get(LOCALE_KEY) || localeSetting,
  }),
  getters: {
    getShowPicker(state): boolean {
      return !!state.localInfo?.showPicker;
    },
    getLocale(state): LocaleType {
      return state.localInfo?.locale ?? localeSetting.fallback;
    },
    getLocaleList(state) {
      return LOCALE_LIST.filter((i) => [...state.localInfo.availableLocales].includes(i.value));
    },
  },
  actions: {
    getLocaleConfig(locale?: LocaleType) {
      if (!locale) locale = this.getLocale;
      return this.getLocaleList.find((i) => i.value === locale);
    },
    /**
     * Set up multilingual information and cache
     * @param info multilingual info
     */
    setLocaleInfo(info: Recordable) {
      this.localInfo = { ...this.localInfo, ...info };
      ls.set(LOCALE_KEY, this.localInfo);
    },
    /**
     * Initialize multilingual information and load the existing configuration from the local cache
     */
    initLocale() {
      this.setLocaleInfo({
        ...localeSetting,
        ...this.localInfo,
      });
    },
  },
});
